import { render, staticRenderFns } from "./ToggleFilterButton.vue?vue&type=template&id=3496c9c0&scoped=true"
import script from "./ToggleFilterButton.vue?vue&type=script&lang=js"
export * from "./ToggleFilterButton.vue?vue&type=script&lang=js"
import style0 from "./ToggleFilterButton.vue?vue&type=style&index=0&id=3496c9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3496c9c0",
  null
  
)

export default component.exports